import { render, staticRenderFns } from "./task_feed.vue?vue&type=template&id=fcc86094&scoped=true"
import script from "./task_feed.vue?vue&type=script&lang=js"
export * from "./task_feed.vue?vue&type=script&lang=js"
import style0 from "./task_feed.vue?vue&type=style&index=0&id=fcc86094&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc86094",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcc86094')) {
      api.createRecord('fcc86094', component.options)
    } else {
      api.reload('fcc86094', component.options)
    }
    module.hot.accept("./task_feed.vue?vue&type=template&id=fcc86094&scoped=true", function () {
      api.rerender('fcc86094', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grow/task_feed.vue"
export default component.exports